import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';

import "./style.css";

import UseSidebar from './../../UseSidebar';
//import SideBarDataComp from "./SideBarData";
//import useSidebar from '../../UseSidebar';
import { getTokenInfo } from './../../UseToken';

import { language } from './Language';

function Sidebar() {
    //const showSidebar = () => setSidebar(!sidebar)
    // //console.log(sidebar);
    // //console.log(showSidebar);

    //PRINT ROUTE
    const { pathname } = useLocation();
    //console.log(pathname);
    //const { sideBarData, getSidebar } = useSidebar();
    const [sideBarData, set_SIDE_BAR] = useState([])
    const [sideBarEntityData, set_SIDE_ENTITY_BAR] = useState([])
    //console.log(props);

    const [lang, set_lang] = useState('pt');

    useEffect(() => {

        (async () => {

            UseSidebar().getSidebar(getTokenInfo().profile).then(v => { set_SIDE_BAR(v); })

            if(getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                let aux = []
                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(v => { aux.push({name: el.name, menu: v}); })
                }
                console.log('»»»»»»»»»»»»»»»»»»»»»» aux', aux)
                set_SIDE_ENTITY_BAR(aux)

            }

        })()

        set_lang(localStorage.getItem('lang'))

        return () => { }
    }, [])

    //const SideBarData = SideBarDataComp(props);
    //console.log(props)

    return (
        <div className={'sidebar left-sidebar'}>
            <div className="sidebar-menu">
                <nav className="sidebar-nav">
                    <ul id="sidebarnav" className="in">
                        {
                        sideBarData.map((item, key) => {
                            //props.sidebar_info.map((item, key) => {
                            if(item.allow === false) {
                                return ''
                            }

                            if(item.separator === 'prev') {
                                // return '<-'
                            }

                            if(item.separator === 'next') {
                                // return '->'
                            }

                            // PARA O CASO DE UMA CLASSNAME ESPECIFICA
                            if(item.title.localeCompare('') === 0) {
                                return (
                                    <li key={key} className={item.cName}></li>
                                )
                            }
                            else if(item.title.startsWith('SEPARADOR')) {
                                return (
                                    <li key={key} className={item.cName + ' mt-3 text-uppercase text-center'}>
                                        <span>
                                            {language[lang][item.title_lang]}
                                        </span>
                                    </li>
                                )
                            }
                            else {
                                if(item.submenu.length > 0 && (item.show_submenu !== undefined && item.show_submenu)) {
                                    let menuActive = false;

                                    /*if(item.path === '/estancia_config_regist'){

                                        console.log('aki aki 1')
                                        console.log('show submenu 1', item.show_submenu)
                                        console.log('item path 1', item.path)
                                        console.log('pathname 1', pathname)
                                        
                                    }*/

                                    item.submenu.map(submenu => {

                                        let path_aux = submenu.path.split('_')
                                        path_aux.pop()
                                        let path_aux_2 = path_aux.join("_")

                                        if(submenu.allow === false) {
                                            return ''
                                        }

                                        if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                            menuActive = true;
                                        }
                                        
                                        if(pathname.startsWith(path_aux_2)) {

                                            // console.log('item.title_lang', item.title_lang)
                                            // console.log('submenu.path', submenu.path)
                                            // console.log('path_aux_2', path_aux_2)
                                            // console.log('######################')

                                            menuActive = true;
                                        }

                                        return menuActive
                                    })

                                    return (
                                        <li key={key}>
                                            <ul>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                <li className={'sidebar-item has-submenu 1111 ' + (menuActive ? " selected" : "")}>
                                                    <NavLink isActive={() => [item.path].includes(pathname)} activeClassName='active' to={item.path} className={"sidebar-link has-arrow"} >
                                                        <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                        <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                                    </NavLink>

                                                    <ul area-expanded='false' className={menuActive ? "collapse first-level base-level-line in" : "collapse first-level base-level-line"}>
                                                        {
                                                        item.submenu.map((submenu, key_2) => {

                                                            if(submenu.allow === false) {
                                                                return ''
                                                            }

                                                            let array_path = pathname.split('_')
                                                            array_path.pop()
                                                            let aux_path = array_path.join("_")

                                                            if(submenu.path.includes(aux_path) && 0) {
                                                                console.log('########################')
                                                                console.log('pathname', pathname)
                                                                console.log('submenu.path', submenu.path)
                                                                console.log('aux_path', aux_path)
                                                                console.log('submenu.path.includes(aux_path)', submenu.path.includes(aux_path + '_list') || submenu.path.includes(aux_path + '_regist') || submenu.path.includes(aux_path + '_view'))
                                                                console.log('########################')
                                                            }

                                                            return (
                                                                <li key={key_2} className={'sidebar-item'}>
                                                                    <NavLink isActive={() => (submenu.path.includes(aux_path + '_list') || submenu.path.includes(aux_path + '_regist') || submenu.path.includes(aux_path + '_view'))} activeClassName='active' to={submenu.path} className={(submenu.title.localeCompare('') === 0 ? 'd-none' : 'sidebar-link') + ((submenu.path.includes(aux_path + '_list') || submenu.path.includes(aux_path + '_regist') || submenu.path.includes(aux_path + '_view')) ? ' active' : '')} >
                                                                        <span className={submenu.cName}></span>
                                                                        <span>{language[lang][submenu.title_lang]}</span>
                                                                    </NavLink>
                                                                </li>
                                                            )
                                                        })
                                                        }
                                                    </ul>
                                                </li>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                            </ul>
                                        </li>
                                    )
                                }
                                //excepção para o caso o item da sidebar tenha sub menus mas eles estiverem ocultos/desabilitados
                                //vai manter na mesma as classes active e selected ao criar ou editar um novo registo
                                if(item.submenu.length > 0 && (item.show_submenu !== undefined && !item.show_submenu)) {
                                    let menuActive = false;

                                    /*if(item.path === '/estancia_meios_list'){

                                        console.log('aki aki 2 ')
                                        console.log('show submenu2 ', !item.show_submenu)
                                        console.log('item path2 ', item.submenu)
                                        //console.log('sub menu path', submenu.path)
                                    }*/

                                    item.submenu.map(submenu => {

                                        if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                            menuActive = true;
                                        }

                                        return menuActive
                                    })

                                    

                                    return (
                                        <li key={key}>
                                            <ul>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                <li className={menuActive ? "sidebar-item selected 2222" : "sidebar-item 22222"}>

                                                    <NavLink isActive={() => menuActive} activeClassName='active' to={item.path} className="sidebar-link" >
                                                        <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                        {/*<span className="hide-menu">{item.title}</span>*/}
                                                        <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                                    </NavLink>

                                                </li>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                            </ul>
                                        </li>
                                    )
                                }
                                else {

                                    /*if(pathname === 'estancia_meios_regist') {
                                        console.log('aki aki 3 ')
                                        console.log('item path 3', item.path)
                                        console.log('show submenu 3', item.show_submenu)
                                        console.log('submenu length 3', item.submenu.length)
                                        console.log('pathname 3', pathname)
                                    }*/

                                    let path_aux = item.path.split('_')
                                    path_aux.pop()
                                    let path_aux_2 = path_aux.join('_').replace('/', '')

                                    if(path_aux_2 !== '') {
                                        path_aux_2 += '_'
                                    }
                                        
                                    return (
                                        <li key={key}>
                                            <ul>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                <li className={item.path.localeCompare(pathname) === 0 || (path_aux_2.localeCompare('') !== 0 && pathname.includes(path_aux_2)) ? "sidebar-item selected" : "sidebar-item"}>
                                                    <NavLink isActive={() => item.path.localeCompare(pathname) === 0 || (path_aux_2.localeCompare('') !== 0 && pathname.includes(path_aux_2))} activeClassName='active' to={item.path} className="sidebar-link" replace>
                                                        <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                        {/*<span>{item.title}</span>*/}
                                                        <span>{language[lang][item.title_lang]}</span>
                                                    </NavLink>
                                                </li>
                                                <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                            </ul>
                                        </li>
                                    )
                                }
                            }
                        })
                        }

                        {
                        sideBarEntityData !== null && sideBarEntityData !== undefined ?
                            sideBarEntityData.map((el, key_el) => {
                                return (
                                    <li key={key_el} className={''}>
                                        <ul>
                                            <li key={key_el} className={'list-divider-profile-title mt-3 text-uppercase text-center'}>{el.name}</li>
                                            {
                                            el.menu.map((item, key) => {
                                                if(item.allow === false) {
                                                    return ''
                                                }

                                                if(item.separator === 'prev') {
                                                    // return '<-'
                                                }

                                                if(item.separator === 'next') {
                                                    // return '->'
                                                }

                                                // PARA O CASO DE UMA CLASSNAME ESPECIFICA
                                                if(item.title.localeCompare('') === 0) {
                                                    return (
                                                        <li key={key} className={item.cName}></li>
                                                    )
                                                }
                                                else if(item.title.startsWith('SEPARADOR')) {
                                                    return (
                                                        <li key={key} className={item.cName + ' mt-3 text-uppercase text-center'}>
                                                            <span>
                                                                {language[lang][item.title_lang]}
                                                            </span>
                                                        </li>
                                                    )
                                                }
                                                else {
                                                    if(item.submenu.length > 0 && (item.show_submenu !== undefined && item.show_submenu)) {
                                                        let menuActive = false;

                                                        item.submenu.map(submenu => {

                                                            let path_aux = submenu.path.split('_')
                                                            path_aux.pop()
                                                            let path_aux_2 = path_aux.join("_")

                                                            if(submenu.allow === false) {
                                                                return ''
                                                            }
                                                            
                                                            if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                                                menuActive = true;
                                                            }
                                                            
                                                            if(pathname.startsWith(path_aux_2)) {
                                                                menuActive = true;
                                                            }

                                                            return menuActive
                                                        })

                                                        return (
                                                            <li key={key}>
                                                                <ul>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                                    <li className={'sidebar-item has-submenu' + (menuActive ? " selected" : "")}>
                                                                        <NavLink isActive={() => [item.path].includes(pathname)} activeClassName='active' to={item.path} className={"sidebar-link has-arrow"} >
                                                                            <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                                            <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                                                        </NavLink>

                                                                        <ul area-expanded='false' className={menuActive ? "collapse first-level base-level-line in" : "collapse first-level base-level-line"}>
                                                                            {
                                                                            item.submenu.map((submenu, key_2) => {

                                                                                if(submenu.allow === false) {
                                                                                    return ''
                                                                                }

                                                                                let array_path = pathname.split('_')
                                                                                array_path.pop()
                                                                                let aux_path = array_path.join("_")

                                                                                return (
                                                                                    <li key={key_2} className={'sidebar-item'}>
                                                                                        <NavLink isActive={() => (submenu.path.includes(aux_path + '_list') || submenu.path.includes(aux_path + '_regist') || submenu.path.includes(aux_path + '_view'))} activeClassName='active' to={submenu.path} className={(submenu.title.localeCompare('') === 0 ? 'd-none' : 'sidebar-link') + ((submenu.path.includes(aux_path + '_list') || submenu.path.includes(aux_path + '_regist') || submenu.path.includes(aux_path + '_view')) ? ' active' : '')} >
                                                                                            <span className={submenu.cName}></span>
                                                                                            <span>{language[lang][submenu.title_lang]}</span>
                                                                                        </NavLink>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                            }
                                                                        </ul>
                                                                    </li>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                    //excepção para o caso o item da sidebar tenha sub menus mas eles estiverem ocultos/desabilitados
                                                    //vai manter na mesma as classes active e selected ao criar ou editar um novo registo
                                                    if(item.submenu.length > 0 && (item.show_submenu !== undefined && !item.show_submenu)) {
                                                        let menuActive = false;

                                                        /*if(item.path === '/estancia_meios_list'){

                                                            console.log('aki aki 2 ')
                                                            console.log('show submenu2 ', !item.show_submenu)
                                                            console.log('item path2 ', item.submenu)
                                                            //console.log('sub menu path', submenu.path)
                                                        }*/

                                                        item.submenu.map(submenu => {

                                                            if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                                                menuActive = true;
                                                            }

                                                            return menuActive
                                                        })

                                                        return (
                                                            <li key={key}>
                                                                <ul>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                                    <li className={menuActive ? "sidebar-item selected" : "sidebar-item"}>

                                                                        <NavLink isActive={() => menuActive} activeClassName='active' to={item.path} className="sidebar-link" >
                                                                            <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                                            {/*<span className="hide-menu">{item.title}</span>*/}
                                                                            <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                                                        </NavLink>

                                                                    </li>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                    else {

                                                        /*if(pathname === 'estancia_meios_regist') {
                                                            console.log('aki aki 3 ')
                                                            console.log('item path 3', item.path)
                                                            console.log('show submenu 3', item.show_submenu)
                                                            console.log('submenu length 3', item.submenu.length)
                                                            console.log('pathname 3', pathname)
                                                        }*/

                                                        
                                                        return (
                                                            <li key={key}>
                                                                <ul>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'prev' ? ' d-none' : ' d-none')}></li>
                                                                    <li className={item.path.localeCompare(pathname) === 0 ? "sidebar-item selected" : "sidebar-item"}>
                                                                        <NavLink isActive={() => [item.path].includes(pathname)} activeClassName='active' to={item.path} className="sidebar-link" replace>
                                                                            <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                                            {/*<span>{item.title}</span>*/}
                                                                            <span>{language[lang][item.title_lang]}</span>
                                                                        </NavLink>
                                                                    </li>
                                                                    <li className={'list-divider p-0 m-0' + (item.separator !== undefined && item.separator === 'next' ? ' d-none' : ' d-none')}></li>
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                }
                                            })
                                            }
                                        </ul>
                                    </li>
                                )
                            })
                        :
                            null
                        }
                    </ul>
                </nav>
            </div>
        </div >
    )
}

export default Sidebar;
